import differenceInCalendarDays from 'date-fns/difference_in_calendar_days';

import {
  DETALIZATION_REPORT_ACTIONS,
  MAX_REPORT_PERIOD_IN_DAYS,
} from './constants';

const isPeriodValid = (startDate, endDate) => differenceInCalendarDays(endDate, startDate) <= MAX_REPORT_PERIOD_IN_DAYS;

export const detalizationReportInitialState = {
  startPeriod: new Date(),
  endPeriod: new Date(),
  isDataValid: true,
  isFetching: false,
  isFetchingSuccess: false,
  isError: false,
  successText: null,
};

const detalizationReport = (state = detalizationReportInitialState, action) => {
  switch (action.type) {
    // DOWNLOAD / SEND REPORT
    case DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT:
    case DETALIZATION_REPORT_ACTIONS.SEND_REPORT:
      return {
        ...state,
        isFetching: true,
        isFetchingSuccess: false,
        isError: false,
      };
    case DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetchingSuccess: true,
        isError: false,
        successText: 'Вы скачали отчет',
      };
    case DETALIZATION_REPORT_ACTIONS.SEND_REPORT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isFetchingSuccess: true,
        isError: false,
        successText: 'Отчёт отправлен на почту',
      };
    case DETALIZATION_REPORT_ACTIONS.DOWNLOAD_REPORT_ERROR:
    case DETALIZATION_REPORT_ACTIONS.SEND_REPORT_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetchingSuccess: false,
        isError: true,
      };
    // SET PERIOD
    case DETALIZATION_REPORT_ACTIONS.SET_PERIOD_START:
      return {
        ...state,
        startPeriod: action.payload,
        isDataValid: isPeriodValid(action.payload, state.endPeriod),
      };

    case DETALIZATION_REPORT_ACTIONS.SET_PERIOD_END:
      return {
        ...state,
        endPeriod: action.payload,
        isDataValid: isPeriodValid(state.startPeriod, action.payload),
      };

    case DETALIZATION_REPORT_ACTIONS.SET_INITIAL_STATE:
      return {
        ...detalizationReportInitialState,
        startPeriod: state.startPeriod,
        endPeriod: state.endPeriod,
      };

    default:
      return state;
  }
};

export default detalizationReport;
